module.exports = "/_next/static/images/Frame2@2x-92406ed86a4e4d70ffe8427cc2e1fa17.webp";